module.exports = __webpack_public_path__ + "img/電気回路_2_3_1.96c2f64b.png";